import React from 'react'
import { Button } from 'antd'
import { PiLightningBold } from 'react-icons/pi'
import IntlMessages from '@vacationtracker/shared/components/utils/IntlMessages'
import { PTOSuggestion } from '../../../types'

interface ActionButtonsProps {
  suggestion: PTOSuggestion
  onRequestClick?: (suggestion: PTOSuggestion) => void
}

export const ActionButtons: React.FC<ActionButtonsProps> = ({
  suggestion,
  onRequestClick,
}) => {

  const handleRequestClick = () => {
    if (onRequestClick) {
      // Navigate to the top of the page.
      // In case we don't do it, half of the leave request form is shown, and user must scroll manually
      window.scrollTo({ top: 0 })

      // Use dayBreakdown to find first and last working days if available
      // If there's only one working day, use it as both start and end date
      // If there are multiple working days, use first as start and last as end
      let modifiedSuggestion = suggestion
      if (suggestion.dayBreakdown && suggestion.dayBreakdown.length > 0) {
        const workingDays = suggestion.dayBreakdown.filter(day => day.isWorkingDay)
        if (workingDays.length > 0) {
          const firstWorkingDay = workingDays[0]
          const lastWorkingDay = workingDays[workingDays.length - 1]

          modifiedSuggestion = {
            ...suggestion,
            startDate: firstWorkingDay.date,
            endDate: lastWorkingDay.date,
          }
        }
      }

      onRequestClick(modifiedSuggestion)
    }
  }

  const energyLabel = null
  // Get energy label based on prediction (Turned off temporary, until we revisit algorithm)
  // suggestion.energyPrediction ? getEnergyLabel(
  //     suggestion.energyPrediction.baselineScore,
  //     suggestion.energyPrediction.predictedScore
  // ) : null

  return (
    <div className="action-buttons">
      <Button
        type="primary"
        onClick={handleRequestClick}
        disabled={!suggestion.leaveTypeId}
        className="action-button-primary"
      >
        <IntlMessages id="energyLevel.requestTheseDates" />
      </Button>

      {energyLabel && (
        <span className="energy-label-tag">
          <PiLightningBold className="energy-label-icon" />
          <IntlMessages id={energyLabel} />
        </span>
      )}
    </div>
  )
}
